import React, { useMemo, useState } from "react";
import {
  Box,
  Button,
  Grid,
  MenuItem,
  TextField,
  FormControlLabel,
  Switch,
  Divider,
  Typography,
} from "@mui/material";

const CURRENCIES = [
  { value: "PEN", label: "PEN" },
  { value: "USD", label: "USD" },
];

const METHODS = [
  { value: "transfer", label: "Transferencia" },
  { value: "cash", label: "Efectivo" },
  { value: "card", label: "Tarjeta" },
  { value: "yape", label: "Yape" },
  { value: "plin", label: "Plin" },
  { value: "deposit", label: "Depósito" },
  { value: "other", label: "Otro" },
];

const todayISO = () => new Date().toISOString().slice(0, 10);

export function AddEditExpenseForm({
  expense,
  categories = [],
  onSubmit,
  onClose,
  onSuccess,
  mode = expense ? "edit" : "create",
}) {
  const [form, setForm] = useState({
    date: expense?.date || todayISO(),
    amount: expense?.amount || "",
    currency: expense?.currency || "PEN",
    method: expense?.method || "transfer",
    category_id: expense?.category?.id || "",
    notes: expense?.notes || "",

    // mínimo requerido


    // opcionales fiscales
    has_invoice: Boolean(expense?.has_invoice),
    supplier_tax_id: expense?.supplier_tax_id || "",
    invoice_series: expense?.invoice_series || "",
    invoice_number: expense?.invoice_number || "",
    invoice_date: expense?.invoice_date || "",
  });

  const handleChange = (e) =>
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const handleSwitch = (e) =>
    setForm((f) => ({ ...f, [e.target.name]: e.target.checked }));

  const amountNum = useMemo(() => {
    const n = parseFloat(form.amount);
    return Number.isFinite(n) ? n : 0;
  }, [form.amount]);

  const submit = async (e) => {
    e.preventDefault();


  

    // payload mínimo + limpio
    const payload = {
      date: form.date || null,
      amount: amountNum,
      currency: form.currency,
      method: form.method,
      category_id: form.category_id ? Number(form.category_id) : null,
      notes: form.notes || "",
  
      has_invoice: Boolean(form.has_invoice),
    };

    // solo si tiene factura mandamos campos fiscales
    if (form.has_invoice) {
      payload.supplier_tax_id = form.supplier_tax_id || "";
      payload.invoice_series = form.invoice_series || "";
      payload.invoice_number = form.invoice_number || "";
      payload.invoice_date = form.invoice_date || null;
    } else {
      // opcional: forzar vacíos para evitar data sucia
      payload.supplier_tax_id = "";
      payload.invoice_series = "";
      payload.invoice_number = "";
      payload.invoice_date = null;
    }

    await onSubmit(payload);
    onSuccess?.();
    onClose?.();
  };

  return (
    <Box component="form" onSubmit={submit}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={4}>
          <TextField
            label="Fecha"
            type="date"
            name="date"
            value={form.date}
            onChange={handleChange}
            fullWidth
            size="small"
            InputLabelProps={{ shrink: true }}
            required
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            label="Monto"
            type="number"
            name="amount"
            value={form.amount}
            onChange={handleChange}
            fullWidth
            size="small"
            required
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            select
            label="Moneda"
            name="currency"
            value={form.currency}
            onChange={handleChange}
            fullWidth
            size="small"
          >
            {CURRENCIES.map((c) => (
              <MenuItem key={c.value} value={c.value}>
                {c.label}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            select
            label="Método"
            name="method"
            value={form.method}
            onChange={handleChange}
            fullWidth
            size="small"
          >
            {METHODS.map((m) => (
              <MenuItem key={m.value} value={m.value}>
                {m.label}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        {/* ✅ Categoría como selector */}
        <Grid item xs={12} sm={6}>
          <TextField
            select
            label="Categoría"
            name="category_id"
            value={form.category_id}
            onChange={handleChange}
            fullWidth
            size="small"
          >
            <MenuItem value="">Sin categoría</MenuItem>
            {categories.map((cat) => (
              <MenuItem key={cat.id} value={cat.id}>
                {cat.name}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

       

        <Grid item xs={12}>
          <TextField
            label="Notas (opcional)"
            name="notes"
            value={form.notes}
            onChange={handleChange}
            fullWidth
            size="small"
            multiline
            rows={2}
          />
        </Grid>

        <Grid item xs={12}>
          <Divider sx={{ my: 1 }} />
          <FormControlLabel
            control={
              <Switch
                checked={Boolean(form.has_invoice)}
                onChange={handleSwitch}
                name="has_invoice"
              />
            }
            label="Tiene factura / comprobante"
          />
          <Typography variant="caption" sx={{ display: "block", opacity: 0.75 }}>
            Actívalo solo si vas a registrar datos fiscales del comprobante.
          </Typography>
        </Grid>

        {/* Campos fiscales (opcionales) */}
        {form.has_invoice && (
          <>
            <Grid item xs={12} sm={4}>
              <TextField
                label="RUC (opcional)"
                name="supplier_tax_id"
                value={form.supplier_tax_id}
                onChange={handleChange}
                fullWidth
                size="small"
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <TextField
                label="Serie (opcional)"
                name="invoice_series"
                value={form.invoice_series}
                onChange={handleChange}
                fullWidth
                size="small"
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <TextField
                label="Número (opcional)"
                name="invoice_number"
                value={form.invoice_number}
                onChange={handleChange}
                fullWidth
                size="small"
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <TextField
                label="Fecha comprobante (opcional)"
                type="date"
                name="invoice_date"
                value={form.invoice_date}
                onChange={handleChange}
                fullWidth
                size="small"
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
          </>
        )}
      </Grid>

      <Box mt={2} display="flex" gap={1} justifyContent="flex-end">
        <Button onClick={onClose}>Cancelar</Button>
        <Button variant="contained" type="submit">
          {mode === "edit" ? "Guardar" : "Crear"}
        </Button>
      </Box>
    </Box>
  );
}
